import React from 'react';
import { useSelector } from 'react-redux';
import { translate } from 'game/translate';
import { UIRootState } from 'ui/store';

export const GameButtons: React.FC = () => {
  const { buttons, indicators, labels } = useSelector((state: UIRootState) => state.gameUI);
  const blockNewGame = buttons.magicWandDisabled || buttons.hintsDisabled;

  const handleButtonClick = (buttonKey: string, data?: any) => {
    document.dispatchEvent(new CustomEvent('ui-button-click', {
      detail: { buttonKey, data }
    }));
  };

  return (
    <>
      <div id="closing-ignore-el" className={`new-game-button new-game-button--secondary ${blockNewGame ? 'new-game-button--disabled' : ''}`} onClick={() => { if (!blockNewGame) handleButtonClick('new-game'); }} style={{ pointerEvents: blockNewGame ? 'none' : 'auto' }}>
        <picture>
          <source srcSet="/assets/menu/new_game.webp" type="image/webp" />
          <img src="/assets/menu/new_game.png" alt="New Game" />
        </picture>
        <span>
          {translate('new_game_button')}
        </span>
      </div>
      
      {buttons.showMagicWand && (
        <button 
          id="magicWandsButton" 
          onClick={() => handleButtonClick('magic-wand')}
          disabled={buttons.magicWandDisabled}
          className="circle-btn btn btn-outline-light border-0 rounded-circle position-relative d-flex align-items-center justify-content-center p-0" 
          style={{ width: '58px', height: '58px' }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <g filter="url(#magic-wand-filter)">
              <path d="M22.4265 4.55139L18.4807 7.62319L13.6922 5.35108C13.3346 5.18141 12.928 5.53303 13.0264 5.92693L14.3192 11.1046L10.634 15.1928C10.3431 15.5154 10.5645 16.0186 10.9829 15.986L14.8271 15.6861C14.9024 15.6759 14.9744 15.6661 15.0433 15.6568C14.0179 17.3067 13.0123 18.7923 12.0151 20.2653C10.6777 22.2411 9.35541 24.1944 8.02122 26.4915C7.88221 26.7308 7.96635 27.0387 8.20908 27.1788L10.5539 28.5326C10.7966 28.6727 11.1063 28.5923 11.2453 28.3529C12.5807 26.0539 13.6237 23.9374 14.6789 21.7962C15.4621 20.2069 16.252 18.6041 17.1731 16.9028C17.1997 16.9623 17.2272 17.0242 17.2559 17.0886L18.9084 20.5617C19.0883 20.9398 19.6362 20.8808 19.7721 20.4687L21.4942 15.2471L26.6418 13.7878C27.0334 13.6768 27.1369 13.1502 26.8113 12.9255L22.4514 9.91598L23.1596 4.97463C23.2198 4.55464 22.7619 4.29028 22.4265 4.55139Z" fill="#FAFAFA"/>
            </g>
            <path d="M5.5 9L5.90054 10.6974C6.18159 11.8885 7.11155 12.8184 8.30259 13.0995L10 13.5L8.30259 13.9005C7.11155 14.1816 6.18159 15.1115 5.90054 16.3026L5.5 18L5.09946 16.3026C4.81841 15.1115 3.88845 14.1816 2.69741 13.9005L1 13.5L2.69741 13.0995C3.88845 12.8184 4.81841 11.8885 5.09946 10.6974L5.5 9Z" fill="#FAFAFA"/>
            <path d="M27 17L27.4341 18.8398C27.6361 19.6957 28.3043 20.3639 29.1602 20.5659L31 21L29.1602 21.4341C28.3043 21.6361 27.6361 22.3043 27.4341 23.1602L27 25L26.5659 23.1602C26.3639 22.3043 25.6957 21.6361 24.8398 21.4341L23 21L24.8398 20.5659C25.6957 20.3639 26.3639 19.6957 26.5659 18.8398L27 17Z" fill="#FAFAFA"/>
            <path d="M9.5 3L9.74663 4.04516C9.88799 4.64424 10.3558 5.11201 10.9548 5.25337L12 5.5L10.9548 5.74663C10.3558 5.88799 9.88799 6.35576 9.74663 6.95484L9.5 8L9.25337 6.95484C9.11201 6.35576 8.64424 5.88799 8.04516 5.74663L7 5.5L8.04516 5.25337C8.64424 5.11201 9.11201 4.64424 9.25337 4.04516L9.5 3Z" fill="#FAFAFA"/>
            <defs>
              <filter id="magic-wand-filter" x="7.9541" y="4.44727" width="19.0508" height="25.1259" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="0.971586"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_magic_wand"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_magic_wand" result="shape"/>
              </filter>
            </defs>
          </svg>
          <span 
            id="magic-wands-indicator" 
            className="position-absolute translate-middle rounded-circle d-flex align-items-center justify-content-center text-white"
            style={{
              justifyContent: 'center',
              fontWeight: 500,
              fontSize: '13px',
              background: '#149246',
              top: '7px',
              left: '88%',
              width: '20px',
              height: '20px'
            }}
          >
            {buttons.magicWandsCount || 'Ad'}
          </span>
        </button>
      )}

      <button 
        id="hintsButton" 
        onClick={() => handleButtonClick('hints')}
        disabled={buttons.hintsDisabled}
        className="circle-btn btn btn-outline-light border-0 rounded-circle position-relative d-flex align-items-center justify-content-center p-0" 
        style={{ width: '58px', height: '58px' }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
          <g filter="url(#hints-filter)">
            <path d="M16.125 4.57422C20.4746 4.57422 24 8.19479 24 12.6602C24 14.9982 23.0222 17.1437 21.1072 19.0649C21.0243 19.148 20.9593 19.2493 20.9169 19.3618L20.8828 19.4747L20.4707 21.3038H11.7793L11.3685 19.4761C11.3334 19.3189 11.2559 19.1759 11.1454 19.0649C9.321 17.2358 8.34581 15.2031 8.25788 12.9934L8.25 12.6602L8.25394 12.3939C8.39175 8.05119 11.8633 4.57422 16.125 4.57422Z" fill="white"/>
            <path d="M20.0625 22.936L19.5704 25.2391C19.3346 26.308 18.4619 27.083 17.4302 27.1662L17.2457 27.1732H15.003C13.9547 27.1732 13.0359 26.4578 12.727 25.4235L12.6783 25.2391L12.1875 22.936H20.0625Z" fill="white"/>
          </g>
          <defs>
            <filter id="hints-filter" x="8.25" y="4.57422" width="15.75" height="23.6157" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="1.01613"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_hints"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_hints" result="shape"/>
            </filter>
          </defs>
        </svg>
        <span 
          id="hints-indicator" 
          className="position-absolute translate-middle rounded-circle d-flex align-items-center justify-content-center text-white"
          style={{
            justifyContent: 'center',
            fontWeight: 500,
            fontSize: '13px',
            background: '#149246',
            top: '7px',
            left: '88%',
            width: '20px',
            height: '20px'
          }}
        >
          {indicators.hintsCount || 'Ad'}
        </span>
      </button>

      <button 
        id="undoButton" 
        onClick={() => handleButtonClick('undo')}
        disabled={buttons.undoDisabled}
        className="circle-btn btn btn-outline-light border-0 rounded-circle position-relative d-flex align-items-center justify-content-center p-0" 
        style={{ width: '58px', height: '58px' }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
          <g filter="url(#undo-filter)">
            <path fillRule="evenodd" clipRule="evenodd" d="M27.4287 11.8517C26.7992 10.3859 25.9519 9.11961 24.8867 8.05442C23.8214 6.98919 22.5551 6.14201 21.0893 5.51228C19.6214 4.88154 18.081 4.56641 16.4688 4.56641C14.9494 4.56641 13.4788 4.85309 12.0577 5.42673C10.6801 5.98289 9.44992 6.76042 8.36821 7.75921L6.474 5.87951C6.30573 5.70596 6.11708 5.59181 5.90763 5.54931C5.69775 5.50672 5.48065 5.53884 5.26071 5.63449C5.03721 5.72968 4.86034 5.86386 4.74002 6.04137C4.61938 6.21935 4.5625 6.43073 4.5625 6.66826V13.5312C4.5625 13.8355 4.67544 14.1008 4.89499 14.3203C5.11462 14.5398 5.37994 14.6528 5.68427 14.6528H12.5471C12.7847 14.6528 12.996 14.5959 13.174 14.4753C13.3514 14.355 13.4855 14.1781 13.5806 13.9547C13.6763 13.7348 13.7084 13.5177 13.6658 13.3078C13.6233 13.0983 13.5092 12.9096 13.3356 12.7413L11.3409 10.7321C12.0172 10.1182 12.7833 9.64242 13.6406 9.30423C14.543 8.94826 15.4853 8.77011 16.4687 8.77011C17.5117 8.77011 18.5066 8.97331 19.4539 9.37912C20.4035 9.7861 21.2228 10.3354 21.9142 11.0267C22.6055 11.7179 23.1548 12.5375 23.5618 13.4871C23.9675 14.4344 24.1706 15.4289 24.1706 16.4723C24.1706 17.5157 23.9675 18.5102 23.5618 19.4575C23.1548 20.407 22.6055 21.2265 21.9142 21.9179C21.2228 22.6092 20.4032 23.1586 19.4539 23.5655C18.5066 23.9714 17.5118 24.1744 16.4687 24.1744C15.2747 24.1744 14.1471 23.9137 13.084 23.3924C12.0222 22.8716 11.1258 22.1359 10.3936 21.1833C10.2925 21.0408 10.1335 20.9667 9.94515 20.943L9.93638 20.9419H9.92754C9.74383 20.9419 9.58121 20.9979 9.45011 21.1158L7.34573 23.2353C7.23667 23.345 7.18105 23.4843 7.17463 23.6432C7.1684 23.8013 7.21017 23.9467 7.29969 24.0747L7.30652 24.0837C8.43312 25.4479 9.79778 26.5051 11.3997 27.2542C13.0014 28.0033 14.6917 28.3782 16.4688 28.3782C18.081 28.3782 19.6214 28.0627 21.0893 27.4322C22.5551 26.8028 23.821 25.9553 24.8865 24.8902C25.9518 23.8246 26.799 22.5586 27.4286 21.0929C28.0592 19.6249 28.3743 18.0841 28.3743 16.4722C28.3743 14.8597 28.0591 13.3197 27.4287 11.8517Z" fill="white"/>
          </g>
          <defs>
            <filter id="undo-filter" x="4.5625" y="4.56641" width="23.8115" height="24.6539" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dy="0.842415"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_undo"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_undo" result="shape"/>
            </filter>
          </defs>
        </svg>
      </button>

      
    </>
  );
}; 